import {
  PATHWAYSUBPATHWAYLIST,
  AGENCYSEARCH,
  AGENCYDETAIL,
  AGENCYCUSTOMTABQUESTION,
  AGENCYEMAILSEND,
  CLAIMORG,
  UPDATEORG,
} from "../utils/URLs";
import { post } from "../utils/v2/api";
export const pathwaySubPathwayList = (data, token) =>
  post(`${PATHWAYSUBPATHWAYLIST}`, data, token);
export const agencySearch = (data, token) =>
  post(`${AGENCYSEARCH}`, data, token);
export const agencyDetail = (data, token) =>
  post(`${AGENCYDETAIL}`, data, token);
export const agencyCustomTabQuestion = (data, token) =>
  post(`${AGENCYCUSTOMTABQUESTION}`, data, token);
export const agencyEmailSend = (data, token) =>
  post(`${AGENCYEMAILSEND}`, data, token);
export const claimOrg = (data, token) => post(`${CLAIMORG}`, data, token);
export const updateOrg = (data, token) => post(`${UPDATEORG}`, data, token);
